'use client';

import { Paper, Stack, type SxProps, Typography } from '@mui/material';
import { type ReactNode, useEffect, useRef } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

import ErrorDetails from '../ErrorDetails';

interface Props {
  errorMessage: string | ReactNode;
  errorDetails?: string | ReactNode;

  disableScrollIntoView?: boolean;

  backgroundColor?: string;
  elevation?: number;
  sx?: SxProps;
}

export default function FormError({
  errorMessage,
  errorDetails,
  disableScrollIntoView,
  backgroundColor = campaignManagerTheme.color.elevatedSurface,
  elevation = 0,
  sx,
}: Props) {
  const ref = useRef<any>(undefined);
  useEffect(() => {
    if (ref.current && errorMessage) {
      const headerOffset = 80;
      const elementPosition = ref.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      if (disableScrollIntoView) return;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }, [errorMessage, disableScrollIntoView]);

  return (
    <Paper
      sx={{
        ...sx,
        borderRadius: 2,
        p: 2,
        backgroundColor,
      }}
      elevation={elevation}
      ref={ref}
      className="animated animated.repeat-1 headShake"
    >
      <Stack
        sx={{
          gap: 2,
        }}
      >
        <ErrorMessage errorMessage={errorMessage} />
        {errorDetails && (
          <ErrorDetails
            fontSize={campaignManagerTheme.fontSize.sm}
            details={errorDetails}
          />
        )}
      </Stack>
    </Paper>
  );
}

interface ErrorMessageProps {
  errorMessage: string | ReactNode;
  ref?: any;
}

function ErrorMessage({ errorMessage }: ErrorMessageProps) {
  if (typeof errorMessage === 'string') {
    <Typography variant="body2">{errorMessage}</Typography>;
  }

  return <>{errorMessage}</>;
}
